export default __webpack_public_path__ + "static/media/VisbyCF-Light.3d58d707.otf";